import axios from 'axios';
var qs = require('qs');
const api_url = process.env.REACT_APP_INFLOW_API;

interface QueueTrackerProps {
    account?:string;
    token?: string;
    clientOrg: string;
    userEmail: string;
    queueId: string;
    queueName: string;
    joined: boolean;
}

interface userProps {
    account?:string;
    token?: string;
    clientOrg: string;
    userEmail: string;
}

class _QueueTrackerService {

    /**
     * Activates/Deactivates a Genesys Queue.
     * @param entity Queue to update.
     * @returns Promise<object> object.
     */
    async setQueueTracker(entity: QueueTrackerProps) {
        entity.account = process.env.REACT_APP_INFLOW_API_ACCOUNT_SID;
        entity.token = process.env.REACT_APP_INFLOW_API_AUTH_TOKEN;
        
        var data = qs.stringify(entity);

        var config: any = {
            method: 'post',
            url: `${api_url}apps/queuetracker`,
            headers: { 
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data : data
        };

        return await axios(config);
    }

    /**
     * Exports a User unexported Queue Trackers.
     * @param userData User object with Org and email to export.
     * @returns Promise<object> object.
     */
    async shareQueueTrackers(userData: userProps) {
        userData.account = process.env.REACT_APP_INFLOW_API_ACCOUNT_SID;
        userData.token = process.env.REACT_APP_INFLOW_API_AUTH_TOKEN;
        
        var data = qs.stringify(userData);

        var config: any = {
            method: 'post',
            url: `${api_url}apps/queuetracker/userexport`,
            headers: { 
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data : data
        };

        return await axios(config);
    }
}

export const QueueTrackerService = new _QueueTrackerService();